<template>
  <Listbox
    as="div"
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :disabled="disabled"
    class="relative">
    <ListboxButton
      as="div"
      :id="$attrs.id"
      :tabindex="disabled ? -1 : 0"
      class="form-input relative w-full cursor-default pr-9 text-left"
      :class="disabled ? 'cursor-not-allowed opacity-50' : ''"
    >
      <span :class="selectedLabel === null ? 'text-gray-500' : ''">
        {{ selectedLabel ?? placeholder ?? '\u00A0' }}
      </span>
      <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2.5">
        <ChevronUpDownIcon class="size-4 text-gray-400" />
      </span>
    </ListboxButton>
    <ListboxOptions class="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md border border-white/10 bg-gray-900 shadow-lg shadow-black/30">
      <ListboxOption
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        v-slot="{ active, selected }"
      >
        <div
          class="cursor-pointer border border-transparent px-3 py-2 text-sm text-gray-200"
          :class="[active ? 'dropdown-option-active' : '', selected ? 'dropdown-option-selected' : '']"
        >
          {{ option.label }}
        </div>
      </ListboxOption>
    </ListboxOptions>
  </Listbox>
</template>

<script>
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'
import { ChevronUpDownIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    ChevronUpDownIcon,
  },
  props: {
    modelValue: {
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    selectedLabel() {
      const selected = this.options.find((option) => option.value === this.modelValue)

      return selected?.label ?? null
    },
  },
}
</script>
